import type { CampaignDto } from "src/app/features/Campaign/types/CampaignDto";
import type { CampaignEntity } from "src/app/features/Campaign/types/CampaignEntity";

export const CampaignDtoToEntity = ({ ...rest }: Readonly<CampaignDto>): CampaignEntity => {
    const mapTerminalsToTextarea = (terminals?: string[]): string | undefined =>
        terminals && terminals.length > 0 ? terminals.join("\n") : undefined;

    return {
        ...rest,
        oldSites1: rest.sites1,
        oldSites2: rest.sites2,
        terminals1: rest.terminals1,
        terminals2: rest.terminals2,
        textareaTerminalsInput1: mapTerminalsToTextarea(rest.terminals1),
        textareaTerminalsInput2: mapTerminalsToTextarea(rest.terminals2),
    };
};
